import { MIME_TYPES } from '@mantine/dropzone';

const APP_CONFIG = {
	QUERY_STALE_TIME: 30_000,
	QUERY_CACHE_TIME: 1_800_000,
	QUERY_RETRY: 2,
	HEADER_HEIGHT: 70,
	TABLE_PAGE_SIZES: [15, 50, 100],
	DEFAULT_LANGUAGE: 'PL',
	ADMIN_DEFAULT_ROLE_ID: crypto.randomUUID(),
	DESCRIPTION_MAX_LENGTH: 1000,
	SESSION_STORAGE_KEYS: {
		REFRESH_TOKEN: 'refreshToken',
	},
	MATERIAL_EXTENSIONS: [MIME_TYPES.png, MIME_TYPES.jpeg],
	MATERIAL_FILE_TYPES: ['.glb'],
	MODEL_FILE_TYPES: ['.glb'],
	MAX_TEXTURE_SIZE_IN_MB: 1,
	MAX_MODEL_SIZE_IN_MB: 5,
} as const;

export default APP_CONFIG;
